import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';
import { SocialMediaService } from 'src/app/services/social-media/social-media.service';
import { SessionService } from 'src/app/services/session/session.service';
import { queryStringToJSON } from 'src/app/app.component';

@Component({
  selector: 'app-social-media-redirect',
  templateUrl: './social-media-redirect.component.html',
  styleUrls: ['./social-media-redirect.component.scss'],
  providers: [LoginService]
})
export class SocialMediaRedirectComponent implements OnInit {

  social_media;
  subscription;
  code;
  constructor(private route: ActivatedRoute, private router: Router, private login_service: LoginService, private sm_service: SocialMediaService, private session_service: SessionService) { }

  ngOnInit() {
    this.sm_service.social_media.subscribe((portals: Array<any>) => {
      if (portals && portals.length) {
        this.subscription = this.route.queryParams.subscribe(params => {
          if (params.sid) {
            portals.forEach(portal => {
              if (portal.portal_id == params.sid) {
                this.social_media = params.sid;
                let url_params: any = window.location.search.slice(1);
                let url_params_json = queryStringToJSON(url_params);
                url_params_json.username = url_params_json.code;
                url_params_json.grant_type = 'socialmedia';
                url_params_json.client_id = 't@ll!nt';
                url_params_json.client_secret = 't@ll!nt';

                this.login_service.generateAccessToken(url_params_json).subscribe((resp) => {

                  this.session_service.setSession(resp);
                  this.router.navigate(['/jobs']);
                },
                  (err) => {

                    if (err && err.error && err.error.error == 'invalid_User') {
                      this.router.navigate(['/jobs']);
                    }
                  })
              }
            });
          }
        })
      }
    });
  }
}
